import {
  compileValidationSchema,
  makePropertyCleaner,
  schemaProperties,
} from '@pogokid/schema'
import { ContactRelationshipSchema } from '../../.types/ContactRelationship.schema'
import contactRelationshipSchema from '../../.types/ContactRelationship.schema.json'
import { compileJsonSchema } from '@pogokid/schema/dynamic'

export const validateContactRelationship =
  compileValidationSchema<ContactRelationshipSchema>(
    'ContactRelationship',
    compileJsonSchema(
      contactRelationshipSchema.definitions
        .ContactRelationshipSchema
    )
  )

export const contactRelationshipProperties = schemaProperties(
  contactRelationshipSchema.definitions.ContactRelationshipSchema
)

export const cleanContactRelationshipProperties =
  makePropertyCleaner<ContactRelationshipSchema>(
    contactRelationshipProperties
  )
